export default __webpack_public_path__ + "static/media/polygonBack.8cf5533e.svg";